import { TextField as MuiTextField, InputAdornment } from '@mui/material';
import Lock from '@mui/icons-material/Lock';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Field } from 'react-final-form';
import { showDefaultError } from '../Util';
import { useStyles } from './styles';

export function TextField(props) {
  const { name, type, parse, fieldProps, reference, ...rest } = props;

  return (
    <Field
      name={name}
      type={type}
      parse={parse}
      render={({ input, meta }) => (
        <TextFieldWrapper reference={reference} input={input} meta={meta} name={name} type={type} {...rest} />
      )}
      {...fieldProps}
    />
  );
}

export function TextFieldWrapper(props) {
  const {
    input: { name, value, type, onChange, onBlur, onFocus, ...restInput },
    meta,
    required,
    fullWidth = true,
    helperText,
    showError = showDefaultError,
    variant = 'outlined',
    reference,
    ...rest
  } = props;

  const { error, submitError } = meta;
  const isError = showError({ meta });
  const classes = useStyles();

  return (
    <MuiTextField
      fullWidth={fullWidth}
      helperText={isError ? error || submitError : helperText || ' '}
      error={isError}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      name={name}
      value={value}
      title={value}
      inputRef={reference}
      variant={variant}
      type={type}
      required={required}
      InputProps={{
        endAdornment:
          rest.disabled && !rest.withoutLock ? (
            <InputAdornment
              classes={{
                root: classes.InputAdornmentRoot,
                positionEnd: classes.positionEnd
              }}
              position="end"
            >
              {variant === 'outlined' ? <LockOutlinedIcon /> : <Lock />}
            </InputAdornment>
          ) : undefined,
        required,
        ...restInput
      }}
      {...rest}
    />
  );
}
